(function () {
  "use strict";

  /**
   * Rewards progress bar for the bundle tray ("Your van kit").
   *
   * Listens for `custom-bundle:render` (dispatched by custom-bundle.js after every
   * tray update) and redraws a Turbo-Progress-Bar-style bar against the staged kit
   * total. Tiers, copy and theme variables come from the Turbo app embed's
   * data-campaign-config, so the bar always matches what the cart drawer shows.
   */

  var TRUCK_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
    '<path stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" fill="none" d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/>' +
    '<path stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" fill="none" d="M15 18H9"/>' +
    '<path stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" fill="none" d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62L18.3 8.38a1 1 0 0 0-.78-.38H14"/>' +
    '<circle cx="17" cy="18" r="2" stroke="currentColor" stroke-width="1.75" fill="none"/>' +
    '<circle cx="7" cy="18" r="2" stroke="currentColor" stroke-width="1.75" fill="none"/>' +
    "</svg>";

  var GIFT_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
    '<path stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" fill="none" d="M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>' +
    "</svg>";

  /**
   * The app embed ships the campaign as data-campaign-config on a hidden wrapper, which
   * the app's own script consumes and removes once it boots; after that the only copy
   * is the campaign-config attribute on the widget it renders into the cart drawer.
   */
  function readCampaign() {
    var host = document.querySelector(".progress-bar-wrapper[data-campaign-config]");
    var raw = host ? host.getAttribute("data-campaign-config") : null;
    if (!raw) {
      var widget = document.querySelector("progress-bar-widget[campaign-config]");
      raw = widget ? widget.getAttribute("campaign-config") : null;
    }
    if (!raw) return null;
    try {
      var cfg = JSON.parse(raw);
      if (!cfg || !Array.isArray(cfg.rewards) || !cfg.rewards.length) return null;
      // Only cart-amount goals can be judged from a staged total.
      cfg.rewards = cfg.rewards
        .filter(function (r) {
          return (r.goal_type || cfg.goal_type) === "cart_amount" && r.goal_amount > 0;
        })
        .sort(function (a, b) {
          return a.goal_amount - b.goal_amount;
        });
      return cfg.rewards.length ? cfg : null;
    } catch (e) {
      return null;
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function bubbleIcon(reward) {
    if (reward.discount_type === "free_shipping") return TRUCK_SVG;
    if (reward.discount_type === "free_gift") return GIFT_SVG;
    if (reward.discount_type === "percentage") return escapeHtml(reward.discount_amount + "%");
    var text = reward.formatted_discount || reward.discount_text || "";
    return escapeHtml(text.length > 4 ? text.slice(0, 4) : text);
  }

  class CustomBundleRewards {
    constructor(root) {
      this.root = root;
      this.includeCart = root.dataset.includeCart === "true";
      this.title = root.querySelector(".js-custom-bundle-rewards-title");
      this.badges = root.querySelector(".js-custom-bundle-rewards-badges");
      this.message = root.querySelector(".js-custom-bundle-rewards-message");
      this.fill = root.querySelector(".js-custom-bundle-rewards-fill");
      this.bubbles = root.querySelector(".js-custom-bundle-rewards-bubbles");
      this.track = root.querySelector('[role="progressbar"]');
      this.wrapper = root.querySelector(".progress-bar-wrapper");
      this.campaign = null;
      this.kitTotal = 0;
      this.kitCount = 0;
      this.cartTotal = 0;
      this.format = null;
      this.divisor = 100;

      var self = this;
      var bundle = root.closest("custom-bundle");
      (bundle || document).addEventListener("custom-bundle:render", function (e) {
        self.onRender(e.detail || {});
      });
      // custom-bundle.js may have upgraded and rendered before this listener existed.
      if (bundle && bundle.state && typeof bundle.state.total === "function") {
        this.onRender({
          total: bundle.state.total(),
          count: bundle.state.count(),
          format: bundle.format.bind(bundle),
          divisor: bundle.money ? bundle.money.divisor : 100,
        });
      }

      if (this.includeCart) {
        // Theme pubsub fires after any cart mutation (product forms, drawer qty, bundle commit).
        if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
            self.refreshCart();
          });
          subscribe(PUB_SUB_EVENTS.cartItemAdd, function () {
            self.refreshCart();
          });
        }
      }

      this.loadCampaign();
    }

    /** Picks up the Turbo campaign now or, if its script has not rendered yet, soon. */
    loadCampaign() {
      if (this.campaign) return true;
      var cfg = readCampaign();
      if (!cfg) {
        if (this.loadAttempts === undefined) this.loadAttempts = 0;
        if (this.loadAttempts < 40) {
          // ~10s of polling covers the app's deferred script and its first drawer render.
          this.loadAttempts += 1;
          var self = this;
          setTimeout(function () {
            self.loadCampaign();
          }, 250);
        }
        return false;
      }
      this.campaign = cfg;
      this.applyStyle();
      this.buildBubbles();
      if (this.title && cfg.config && cfg.config.text_title) {
        this.title.textContent = cfg.config.text_title;
      }
      if (this.includeCart) this.refreshCart();
      this.draw();
      return true;
    }

    applyStyle() {
      var styling = this.campaign.styling || (this.campaign.config && this.campaign.config.style) || {};
      var el = this.wrapper || this.root;
      Object.keys(styling).forEach(function (k) {
        if (k.indexOf("--") === 0 && styling[k] !== "" && styling[k] != null) {
          el.style.setProperty(k, styling[k]);
        }
      });
    }

    maxGoal() {
      var r = this.campaign.rewards;
      return r[r.length - 1].goal_amount;
    }

    buildBubbles() {
      if (!this.bubbles) return;
      var max = this.maxGoal();
      var html = "";
      this.campaign.rewards.forEach(function (reward, i, arr) {
        var left = (reward.goal_amount / max) * 100;
        var cls = "reward-bubble type-" + escapeHtml(reward.discount_type || "custom");
        if (i === arr.length - 1 && arr.length > 1) cls += " tooltip-right";
        if (i === 0 && arr.length > 1 && left < 20) cls += " tooltip-left";
        var label = reward.formatted_discount || reward.discount_text || "";
        var goal = reward.formatted_goal || "";
        html +=
          '<div class="' + cls + '" data-goal="' + reward.goal_amount + '" style="left:' + left + '%" title="' +
          escapeHtml(label + (goal ? " (" + goal + ")" : "")) + '">' +
          '<div class="bubble-icon">' + bubbleIcon(reward) + "</div>" +
          '<div class="bubble-tooltip"><strong>' + escapeHtml(label) + "</strong>" +
          (goal ? "<span>(" + escapeHtml(goal) + ")</span>" : "") +
          "</div></div>";
      });
      this.bubbles.innerHTML = html;
    }

    refreshCart() {
      var self = this;
      if (window.progressBarCart && typeof window.progressBarCart.total_price === "number") {
        this.cartTotal = window.progressBarCart.total_price;
        this.draw();
      }
      fetch(window.routes && window.routes.cart_url ? window.routes.cart_url + ".js" : "/cart.js", {
        headers: { Accept: "application/json" },
      })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (cart) {
          if (cart && typeof cart.total_price === "number") {
            self.cartTotal = cart.total_price;
            self.draw();
          }
        })
        .catch(function () {});
    }

    onRender(detail) {
      this.kitTotal = detail.total || 0; // minor units
      this.kitCount = detail.count || 0;
      if (typeof detail.format === "function") this.format = detail.format;
      if (detail.divisor) this.divisor = detail.divisor;
      this.draw();
    }

    money(minor) {
      if (this.format) return this.format(minor);
      var shop = this.campaign.shop || {};
      if (shop.money_format) {
        return shop.money_format.replace("{{amount}}", (minor / this.divisor).toFixed(2));
      }
      // Standalone bar (no bundle tray to borrow a formatter from): use the shop currency.
      try {
        var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP";
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: "currency",
          currency: currency,
        }).format(minor / this.divisor);
      } catch (e) {
        return (minor / this.divisor).toFixed(2);
      }
    }

    draw() {
      // Standalone (include_cart) bars, e.g. the one above collection grids, show the
      // cart's own progress even with nothing staged; tray bars wait for a first item.
      var hidden = !this.campaign || (this.kitCount === 0 && !this.includeCart);
      if (this.root.hidden !== hidden) this.root.hidden = hidden;
      if (hidden) return;

      var totalMinor = this.kitTotal + (this.includeCart ? this.cartTotal : 0);
      var total = totalMinor / this.divisor; // major units, matches goal_amount
      var rewards = this.campaign.rewards;
      var max = this.maxGoal();
      var ratio = Math.min(total / max, 1);

      if (this.fill) this.fill.style.width = ratio * 100 + "%";
      if (this.track) this.track.setAttribute("aria-valuenow", String(Math.round(ratio * 100)));

      // Bubbles: unlocked state.
      var unlocked = [];
      var next = null;
      var nodes = this.bubbles ? this.bubbles.querySelectorAll(".reward-bubble") : [];
      rewards.forEach(function (reward, i) {
        var hit = total >= reward.goal_amount;
        if (hit) unlocked.push(reward);
        else if (!next) next = reward;
        var node = nodes[i];
        if (node) {
          node.classList.toggle("unlocked", hit);
          node.classList.toggle("will-unlock", !hit && next === reward);
        }
      });

      // Badge: the best unlocked reward (accumulating tiers replace each other).
      if (this.badges) {
        var best = null;
        unlocked.forEach(function (r) {
          if (r.discount_type === "free_shipping") return;
          best = r; // sorted ascending, so last wins
        });
        var badgeHtml = best
          ? '<span class="active-discount">' + escapeHtml(best.formatted_discount || best.discount_text || "") + "</span>"
          : "";
        if (this.badges.innerHTML !== badgeHtml) this.badges.innerHTML = badgeHtml;
      }

      // Message.
      if (this.message) {
        var text;
        if (next) {
          var remaining = Math.max(next.goal_amount * this.divisor - totalMinor, 0);
          var tpl = next.unfulfilled_goal_text || "Spend {{amount}} more to unlock {{reward}}";
          text = tpl
            .split("{{amount}}").join(this.money(remaining))
            .split("{{reward}}").join(next.formatted_discount || next.discount_text || "");
        } else {
          text = this.campaign.fulfilled_goal_text || "You've unlocked all your rewards!";
        }
        if (this.message.textContent !== text) this.message.textContent = text;
      }
    }
  }

  function init() {
    document.querySelectorAll(".js-custom-bundle-rewards").forEach(function (root) {
      if (root._rewards) return;
      root._rewards = new CustomBundleRewards(root);
    });
  }

  // Have <custom-bundle> announce every tray update without editing custom-bundle.js:
  // wrap its render() once the element is defined.
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined("custom-bundle").then(function () {
      var proto = customElements.get("custom-bundle").prototype;
      if (proto._rewardsPatched) return;
      proto._rewardsPatched = true;
      var render = proto.render;
      proto.render = function () {
        render.apply(this, arguments);
        if (!this.state) return;
        this.dispatchEvent(
          new CustomEvent("custom-bundle:render", {
            bubbles: true,
            detail: {
              total: this.state.total(),
              count: this.state.count(),
              format: this.format.bind(this),
              divisor: this.money ? this.money.divisor : 100,
            },
          }),
        );
      };
      // Elements that rendered before the patch: push their current state out now.
      document.querySelectorAll("custom-bundle").forEach(function (el) {
        if (el.state) el.render();
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  // Theme editor re-renders the section on setting changes.
  document.addEventListener("shopify:section:load", init);
})();
